//For Slot Index Use
import React, { Fragment } from 'react';
import { Translation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { mapStateToProps } from '../../../redux/selector/selector';
import { withRouter } from 'react-router-dom';
import MainLayout from 'root/layout/MainLayout';
// import Banner from '../Banner';
import Recommended from 'root/pages/01Home/home/Recommended';
import Promotions from 'root/components/Promotions';
import Search from './slots/Search';
import { bannerContent } from '../BannerContent';
import SVGElements from 'root/components/SVGElements';
import { gu_getSettingFromPortalSettings } from '@utils/general-util';
import ProductBanner from '@components/organisms/product-banner/product-banner';

class Slots extends React.Component {
    isMount = true;
    constructor(props) {
        super(props);

        this.state = {
            menus: [],
            submenus: [],
            displaySubmenu: [],
            recommendSlideRow: 1,
            compSettings: [],
        };
    }

    componentDidMount() {
        this.isMount = true;
        this.initCompSettings();
        this.getDisplayMenu();
        this.getDisplaySubCategory();
        this.updateDomainURL();
    }

    initCompSettings() {
        return new Promise((resolve) => {
            // Step 1: Standard way to get from portal settings
            let showCustomBannerContent = gu_getSettingFromPortalSettings({
                vm: this,
                settingName: 'showCustomBannerContent',
            });
            // Step 2: Massage again to get the specific data you need (Skip if not needed)

            // Step 3: Initial all into compSettings
            const { language } = this.props;
            let compSettings = {
                showCustomBannerContent: Object.keys(showCustomBannerContent).length > 0 ? showCustomBannerContent.includes(language.currencyLang) : false,
            };
            // Use setState callback to ensure the state has been updated before logging
            this.setState({ compSettings: compSettings }, () => {
                resolve();
            });
        });
    }

    componentWillUnmount() {
        this.isMount = false;
    }

    getDisplayMenu = () => {
        const { language } = this.props;
        let screen = '';

        if (this.props.screen.isMobile) {
            screen = 'mobile';
        } else {
            screen = 'web';
        }

        window.SPL_Content.getDisplayMenu(language.countryLanguageKey, screen).then((data) => {
            if (this.isMount) {
                this.setState({ menus: data });
            }
        });
    };

    getDisplaySubCategory = () => {
        const { language } = this.props;
        let screen = '';

        if (this.props.screen.isMobile) {
            screen = 'mobile';
        } else {
            screen = 'web';
        }

        let loadGetDisplaySubCategory = new Promise((resolve) => {
            window.SPL_Content.getDisplaySubCategory(language.countryLanguageKey, screen).then((data) => resolve(data));
        });

        let loadProviderGameMaintenanceList = new Promise((resolve) => {
            window.SPL_Provider.providerGameMaintenanceList(null, null, language.currencyLang).then((result) => resolve(result));
        });

        Promise.all([loadGetDisplaySubCategory, loadProviderGameMaintenanceList]).then((loadResult) => {
            let subCategory = loadResult[0];
            let providerMaintenance = loadResult[1];

            if (this.isMount) {
                this.setState({ submenus: subCategory }, () => {
                    let displaySubmenuObj = this.state.submenus.filter((s) => s.link === 'SL')[0];
                    let displaySubmenu = [];

                    if (displaySubmenuObj) {
                        displaySubmenu = displaySubmenuObj.submenu;
                    }

                    for (let i = 0; i < displaySubmenu.length; i++) {
                        let provider = displaySubmenu[i].provider;

                        if (!providerMaintenance) continue;
                        for (let j = 0; j < providerMaintenance.length; j++) {
                            let maintenanceProvider = providerMaintenance[j].provider;

                            if (provider === maintenanceProvider) {
                                displaySubmenu[i].underMaintenance = providerMaintenance[j];
                            }
                        }
                    }

                    this.setState({ displaySubmenu: displaySubmenu });
                });
            }
        });
    };

    customProviderBanner = () => {
        const { language, screen } = this.props;
        const { showCustomBannerContent } = this.state.compSettings;
        let bannerImg = '096-slot-bn1.webp';
        // Check conditions and update path accordingly
        if (!showCustomBannerContent) {
            bannerImg = `${screen?.isMobile ? 'm-' : ''}${language.key}-${bannerImg}`;
        }
        return `/public/html/images/slot_img/${bannerImg}`;
    };

    updateDomainURL = () => {
        const { pathname, origin } = window.location;
        const countryLanguageKey = window.localStorage.LANGUAGE_CURRENCY ? window.localStorage.LANGUAGE_CURRENCY.replace('_', '-').toLowerCase() : 'en-my'; // Convert to lowercase with hyphen or default to "en-my"

        if ((pathname.includes('/m/') && pathname.split('/m/')[1] !== '') || pathname.includes('/slots/nextspin')) {
            const newPath = `${origin}/${countryLanguageKey}/slots`;
            window.history.replaceState(null, '', newPath);
        }
    };

    render() {
        const { key, countryLanguageKey, currencyLang } = this.props.language;
        const { showCustomBannerContent } = this.state.compSettings;

        const isShowRecommend = this.props.location.search.includes('recommend');

        let languageKey = key;
        if (key === 'zh-CN') {
            languageKey = 'zh';
        }

        const BannerInfo = [
            <Translation>
                {(t) => (
                    <div className='banner-item'>
                        <img src={this.customProviderBanner()} alt='banner' />

                        <div className='content-container'>
                            {showCustomBannerContent && (
                                <>
                                    <div className='slide-text-box'>
                                        {bannerContent && bannerContent['SL'] && bannerContent['SL'][languageKey] && (
                                            <Fragment>
                                                <p className='text-banner-green'>
                                                    <span className='green-content'>{bannerContent['SL'][languageKey].text_1 && bannerContent['SL'][languageKey].text_1}</span>
                                                </p>
                                                <p className='text-banner-white'>
                                                    <span className='white-content'>{bannerContent['SL'][languageKey].text_2 && bannerContent['SL'][languageKey].text_2}</span>
                                                    <span className='white-content'>{bannerContent['SL'][languageKey].text_3 && bannerContent['SL'][languageKey].text_3}</span>
                                                    <span></span>
                                                </p>
                                                <p className='text-banner-content'>
                                                    {/* {bannerContent['SL'][languageKey].text_4 && bannerContent['SL'][languageKey].text_4} */}
                                                </p>
                                            </Fragment>
                                        )}
                                    </div>
                                    {/* <div className='provider-logo slot-logo1'> */}
                                    <div className='provider-logo nextspin-logo'>
                                        {/* <img src='/public/html/images/provider_logo/096-ns-icon.png' /> */}
                                        <SVGElements className='NS' name='NS' />
                                    </div>
                                    {/* <div className="btn-skew to-claim">
                <span>{t('global:footer.playNow', 'PLAY NOW')}</span>
              </div> */}
                                </>
                            )}
                        </div>
                    </div>
                )}
            </Translation>,
        ];

        const BannerInfo2 = [
            <Translation>
                {(t) => (
                    <div className='banner-item'>
                        <img src={this.customProviderBanner()} alt='banner' />

                        <div className='content-container'>
                            {currencyLang === 'VND' && (
                                <>
                                    <div className='slide-text-box'>
                                        {bannerContent && bannerContent['SL'] && bannerContent['SL'][languageKey] && (
                                            <Fragment>
                                                <p className='text-banner-green'>{bannerContent['SL'][languageKey].text_1 && bannerContent['SL'][languageKey].text_1}</p>
                                                <p className='text-banner-white'>
                                                    {bannerContent['SL'][languageKey].text_2 && bannerContent['SL'][languageKey].text_2} <br />
                                                    {bannerContent['SL'][languageKey].text_3 && bannerContent['SL'][languageKey].text_3}
                                                </p>
                                                {/* <p className="text-banner-content dt-only">
                      {bannerContent['SL'][languageKey].text_4 && bannerContent['SL'][languageKey].text_4}
                    </p> */}
                                            </Fragment>
                                        )}
                                    </div>
                                    {/* <div className='provider-logo slot-logo1'> */}
                                    <div className='provider-logo'>
                                        {/* <img src='/public/html/images/provider_logo/096-ns-icon.png' /> */}
                                        <SVGElements className='NS' name='NS' />
                                    </div>
                                    {/* <div className="btn-skew to-claim">
                <span>{t('global:footer.playNow', 'PLAY NOW')}</span>
              </div> */}
                                </>
                            )}
                        </div>
                    </div>
                )}
            </Translation>,
        ];

        return (
            <Translation>
                {(t) => (
                    <MainLayout>
                        <div className='slots'>
                            <ProductBanner prefix={'SL'} />
                            {/* <Banner BannerInfo={countryLanguageKey.includes('SG') ? BannerInfo2 : BannerInfo} /> */}
                            <div className='slots-container content-container'>
                                <div className='content-section'>
                                    <ul className='slots-content-section'>
                                        {(!this.props.screen.isMobile || isShowRecommend) && (
                                            <li className='content-recommended'>
                                                <Recommended recommendSlideRow={this.state.recommendSlideRow} />
                                            </li>
                                        )}

                                        <li className='content-sort-search '>
                                            <Search />
                                        </li>
                                        <li className='content-promotions'>
                                            <Promotions />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </MainLayout>
                )}
            </Translation>
        );
    }
}

export default connect(mapStateToProps)(withTranslation()(withRouter(Slots)));
